import React from 'react'
import { QuickLinksCard, QuickLinksCardProps } from './QuickLinksCard'
import { QuickLinksItem, QuickLinksItemProps } from './QuickLinksItem'
import { QuickLinksWrapper, QuickLinksWrapperProps } from './QuickLinksWrapper'
import { QuickLinksAccordianCard } from './QuickLinksAccordionCard'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

export type QuickLinksProps = (
  | ({ card: true; item?: false } & QuickLinksCardProps)
  | ({ card?: false; item: true } & QuickLinksItemProps)
  | ({ card?: false; item?: false } & QuickLinksWrapperProps)
)

//TO DO: Remove `as type` with TypeScript Magic
export const QuickLinks: React.VFC<QuickLinksProps> = ({ card, item, ...props }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  if (item) {
    return <QuickLinksItem { ...props as QuickLinksItemProps} />
  }
  
  if (card) {
    return (isMobile) ? 
      (<QuickLinksAccordianCard { ...props as QuickLinksCardProps} />) : 
      (<QuickLinksCard { ...props as QuickLinksCardProps} />)
  }

  return <QuickLinksWrapper { ...props as QuickLinksWrapperProps} />
}